<template>
  <div class="gender" v-if="this.items.length > 1">
    <button v-for="item in items" :key="item.id" @click="change" :data="item.id" :title="item.nameFr+' ['+item.id+']'">{{ item.nameFr }}</button>
  </div>
</template>

<script>
export default {
  name: 'SportGamesFiltersEventGender',
  data () {
    return {
      value: null
    }
  },
  computed: {
    items () {
      const filter = this.$store.getters['Sport/Gender/filtered']
      return this.$store.getters['Sport/Gender/list'].filter(item => filter.indexOf(item.id) > -1)
    }
  },
  methods: {
    change (event) {
      const button = event.target
      const value = parseInt(button.getAttribute('data'))
      if (value === this.value) {
        this.value = null
        button.className = ''
      } else {
        button.parentNode.querySelectorAll('button').forEach(item => { item.className = '' })
        this.value = value
        button.className = 'selected'
      }
      this.$emit('change', this.value)
    }
  }
}
</script>

<style scoped>
  .gender{
    display:flex;
    background-color:var(--color-primary);
    padding:5px;
    border-radius:4px
  }
  .gender > button{
    background-color:transparent;
    border-width:1px 0 1px 1px;
    border-style:solid;
    flex:auto;
    cursor:pointer;
    transition:all .5s ease-in-out
  }
  .gender > button:first-child{
    border-radius:4px 0 0 4px
  }
  .gender > button:last-child{
    border-radius:0 4px 4px 0;
    border-right-width:1px
  }
  .gender > button:hover{
    color:var(--color-primary-bg)
  }
  .gender > button.selected{
    background-color:var(--color-primary-bg);
    color:var(--color-primary);
  }
</style>
